module.exports = __webpack_public_path__ + "img/cancle.d6648dd4.svg";